// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RentalNeedPriceRange = require("../RentalNeedPriceRange.bs.js");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RenewRentalNeedMutation = require("../ClientPage/RenewRentalNeedMutation.bs.js");
let MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
let OwnRentalNeedStatusLabel = require("../OwnRentalNeedStatusLabel.bs.js");
let WithdrawRentalNeedDialog = require("../ClientPage/WithdrawRentalNeedDialog.bs.js");
let MyClientsWidgetComponents = require("./MyClientsWidgetComponents.bs.js");
let MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
let MarkRentalNeedAsRentedDialog = require("../ClientPage/MarkRentalNeedAsRentedDialog.bs.js");
let MyClientsWidgetRenter_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_renter_graphql.bs.js");
let MyClientsWidgetRenter_Menu_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_Menu_renter_graphql.bs.js");
let MyClientsWidgetRenter_name_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_name_renter_graphql.bs.js");
let MyClientsWidgetRenter_status_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_status_renter_graphql.bs.js");
let MyClientsWidgetRenter_rowDetails_renter_graphql = require("../../../__generated__/MyClientsWidgetRenter_rowDetails_renter_graphql.bs.js");
let MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed_graphql = require("../../../__generated__/MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed_graphql.bs.js");

let convertFragment = MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed_graphql.node, convertFragment, fRef);
}

let RentalNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetRenter$Menu$ActivityReportMenuItem(props) {
  let rentalNeed = RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed_graphql.node, convertFragment, props.rentalNeed);
  let hasActivityReport = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.map(rentalNeed.broadcasts, connection => connection.edges), [])).some(edge => {
    let match = edge.node.activityReport;
    return match.__typename === "ActivityReportV5";
  });
  if (hasActivityReport) {
    return JsxRuntime.jsx(MenuV5.MenuItem.make, {
      href: `/client_needs/` + rentalNeed.id + `/report`,
      children: "View activity report"
    });
  } else {
    return null;
  }
}

let ActivityReportMenuItem = {
  RentalNeedFragment: RentalNeedFragment,
  make: MyClientsWidgetRenter$Menu$ActivityReportMenuItem
};

let convertFragment$1 = MyClientsWidgetRenter_Menu_renter_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment$1, fRef);
}

let RenterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetRenter$Menu(props) {
  let renter = RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_Menu_renter_graphql.node, convertFragment$1, props.renter);
  let rentalNeed = renter.rentalNeed;
  let match = React.useState(() => false);
  let setDeleteDialogOpen = match[1];
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let handleRenewingError = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was an error making the rental need active. Please try again...", 5000, undefined, undefined));
  let match$2 = RenewRentalNeedMutation.use(rentalNeed.nodeId, handleRenewingError, true);
  let makeRentalNeedActiveIsLoading = match$2[1];
  let makeRentalNeedActive = match$2[0];
  let match$3 = React.useState(() => false);
  let setWithdrawDialogOpen = match$3[1];
  let match$4 = React.useState(() => false);
  let setMarkRentedDialogOpen = match$4[1];
  let match$5 = renter.rentalNeed.status;
  let tmp;
  switch (match$5.__typename) {
    case "ActiveRentalNeed" :
      tmp = match$5.isRenewable ? "Renew or change status" : "Change status";
      break;
    case "ExpiredRentalNeed" :
      tmp = "Renew or change status";
      break;
    default:
      tmp = "Change status";
  }
  let match$6 = renter.rentalNeed.status;
  let tmp$1;
  let exit = 0;
  switch (match$6.__typename) {
    case "ActiveRentalNeed" :
      if (match$6.isRenewable) {
        exit = 1;
      } else {
        tmp$1 = null;
      }
      break;
    case "ExpiredRentalNeed" :
      exit = 1;
      break;
    default:
      tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => {
          makeRentalNeedActive();
        },
        isDisabled: makeRentalNeedActiveIsLoading,
        children: "Change to active"
      });
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => {
        makeRentalNeedActive();
      },
      isDisabled: makeRentalNeedActiveIsLoading,
      children: "Renew property"
    });
  }
  let match$7 = renter.rentalNeed.status;
  let tmp$2;
  tmp$2 = match$7.__typename === "RentedRentalNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => setMarkRentedDialogOpen(param => true),
      children: "Mark as rented"
    });
  let match$8 = renter.rentalNeed.status;
  let tmp$3;
  tmp$3 = match$8.__typename === "WithdrawnRentalNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => setWithdrawDialogOpen(param => true),
      children: "Withdraw rental need"
    });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(WithdrawRentalNeedDialog.make, {
        nodeId: rentalNeed.nodeId,
        isOpen: match$3[0],
        close: () => setWithdrawDialogOpen(param => false)
      }),
      JsxRuntime.jsx(MarkRentalNeedAsRentedDialog.make, {
        nodeId: rentalNeed.nodeId,
        isOpen: match$4[0],
        close: () => setMarkRentedDialogOpen(param => false)
      }),
      JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
        client: renter.fragmentRefs,
        isOpen: match[0],
        onCancel: () => setDeleteDialogOpen(param => false),
        onSuccess: () => setDeleteDialogOpen(param => false),
        connectionId: props.connectionId
      }),
      JsxRuntime.jsxs(MenuV5.Menu.make, {
        button: JsxRuntime.jsx(ButtonsV5.Button.make, {
          className: "!border-none",
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "three-dots",
            size: 16,
            className: "text-black"
          })
        }),
        children: [
          JsxRuntime.jsx(MenuV5.MenuItem.make, {
            href: `/client_needs/` + renter.rentalNeed.id + `/edit`,
            children: "Edit rental need"
          }),
          JsxRuntime.jsxs(MenuV5.Submenu.make, {
            name: tmp,
            children: [
              tmp$1,
              tmp$2,
              tmp$3
            ]
          }),
          JsxRuntime.jsx(React.Suspense, {
            children: JsxRuntime.jsx(MyClientsWidgetRenter$Menu$ActivityReportMenuItem, {
              rentalNeed: rentalNeed.fragmentRefs
            }),
            fallback: null
          }),
          JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: () => setDeleteDialogOpen(param => true),
            children: "Delete renter"
          })
        ]
      })
    ]
  });
}

let Menu = {
  ActivityReportMenuItem: ActivityReportMenuItem,
  RenterFragment: RenterFragment,
  make: MyClientsWidgetRenter$Menu
};

let convertFragment$2 = MyClientsWidgetRenter_name_renter_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$2, fRef);
}

let RenterFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetRenter$Name(props) {
  let renter = RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_name_renter_graphql.node, convertFragment$2, props.renter);
  let areaNames = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.flatMap(renter.rentalNeed.areas, areas => areas.edges), [])).map(edge => edge.node.name);
  let areaText = MyClientsWidgetComponents.areaPreview(areaNames, undefined);
  let supportingText = Stdlib_Option.getOr(Stdlib_Option.map(areaText, area => JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("span", {
        children: "•",
        className: "text-gray-400"
      }),
      JsxRuntime.jsx("span", {
        children: area
      })
    ]
  })), null);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: "Rental Need",
          className: "text-gray-500 text-sm font-semibold uppercase tracking-wide"
        }),
        className: "flex gap-2"
      }),
      JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: `my_clients/` + renter.id,
        children: JsxRuntime.jsx("div", {
          children: renter.displayName,
          className: "text-lg font-medium"
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(RentalNeedPriceRange.make, {
            rentalNeed: renter.rentalNeed.fragmentRefs,
            size: "small",
            className: "!text-base sm:!text-base !font-normal !text-gray-500"
          }),
          supportingText
        ],
        className: "text-base text-gray-500 flex flex-wrap items-center gap-x-1"
      })
    ],
    className: "flex flex-col gap-1"
  });
}

let Name = {
  RenterFragment: RenterFragment$1,
  make: MyClientsWidgetRenter$Name
};

let convertFragment$3 = MyClientsWidgetRenter_status_renter_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$3, fRef);
}

let RenterFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetRenter$Status$WithoutErrorBoundary(props) {
  let renter = RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_status_renter_graphql.node, convertFragment$3, props.renter);
  return JsxRuntime.jsx(OwnRentalNeedStatusLabel.make, {
    rentalNeed: renter.rentalNeed.fragmentRefs
  });
}

let WithoutErrorBoundary = {
  RentalNeedStatusLabel: undefined,
  RenterFragment: RenterFragment$2,
  make: MyClientsWidgetRenter$Status$WithoutErrorBoundary
};

function MyClientsWidgetRenter$Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "rental need status",
    children: JsxRuntime.jsx(MyClientsWidgetRenter$Status$WithoutErrorBoundary, {
      renter: props.renter
    })
  });
}

let Status = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: MyClientsWidgetRenter$Status
};

let convertFragment$4 = MyClientsWidgetRenter_rowDetails_renter_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_rowDetails_renter_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_rowDetails_renter_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_rowDetails_renter_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_rowDetails_renter_graphql.node, convertFragment$4, fRef);
}

let RenterFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function MyClientsWidgetRenter$RowDetails(props) {
  let rowDetails = RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_rowDetails_renter_graphql.node, convertFragment$4, props.renter);
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
    name: props.name,
    status: props.status,
    matches: JsxRuntime.jsx(MyClientsWidgetComponents.MatchesSummary.make, {
      matchable: rowDetails.rentalNeed.fragmentRefs,
      clientId: rowDetails.id
    }),
    menu: props.menu,
    dim: false
  });
}

let RowDetails = {
  RenterFragment: RenterFragment$3,
  make: MyClientsWidgetRenter$RowDetails
};

let convertFragment$5 = MyClientsWidgetRenter_renter_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetRenter_renter_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_renter_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetRenter_renter_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetRenter_renter_graphql.node, convertFragment$5, fRef);
}

let RenterFragment$4 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function MyClientsWidgetRenter(props) {
  let renter = RescriptRelay_Fragment.useFragment(MyClientsWidgetRenter_renter_graphql.node, convertFragment$5, props.renter);
  return JsxRuntime.jsx(MyClientsWidgetRenter$RowDetails, {
    renter: renter.fragmentRefs,
    name: JsxRuntime.jsx(MyClientsWidgetRenter$Name, {
      renter: renter.fragmentRefs
    }),
    status: JsxRuntime.jsx(MyClientsWidgetRenter$Status, {
      renter: renter.fragmentRefs
    }),
    menu: JsxRuntime.jsx(MyClientsWidgetRenter$Menu, {
      renter: renter.fragmentRefs,
      connectionId: props.connectionId
    })
  });
}

let Components;

let Link;

let DeleteDialog;

let make = MyClientsWidgetRenter;

exports.Components = Components;
exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Name = Name;
exports.Status = Status;
exports.RowDetails = RowDetails;
exports.RenterFragment = RenterFragment$4;
exports.make = make;
/* react Not a pure module */
